import React from 'react';

export default {
  en: {
    'pageTitle': 'Battle for Binance Futures',
    'slogon': 'the Futures Are in Your Hands!',
    'tradeCompetitionPeriod': 'Trading Competition Period',
    'bannerDesc': `We are delighted to announce the launch of not one, but two Binance Futures Testnet Platforms to 
    better serve our users! This gives you the freedom to explore each product and its offerings ahead of the official Binance Futures launch. `,
    'Futures A': 'Futures A',
    'Futures B': 'Futures B',
    'chooseA': 'Choose A',
    'chooseB': 'Choose B',
    'PromotionADesc': (
      <>
        Participants can vote for their favorite Futures platform after experiencing both Futures A and Futures B platforms in action.
        At the end of the competition period, the mainnet version of the platform  with the most votes will provide
        <strong> a 50% trading fee discount</strong> to its testnet voters for a full month.
      </>
    ),
    'PromotionBTitle': 'Simulated Trading Competition - 10,000 BNB to be won!',
    'PromotionBDesc1': (
      <>
      All participants will be allocated 100,000 USDT in simulated funds* on each of Futures A and Futures B by signing up for <strong>both</strong> platforms.
      During the competition period, participants will be ranked in terms of the total USDT trading volume transacted
      (including both Buys and Sells) on each of their Binance Futures accounts within the simulated trading pairs.
      </>
    ),
    'PromotionBDesc2': `To be eligible, participants will also be required to maintain at least the originally allocated 100,000 USDT in simulated funds 
    in each of their futures accounts by the end of the competition period. `,
    'Futures A rankings': 'Futures A rankings',
    'Futures B rankings': 'Futures B rankings',
    'rewardTableTip': 'Rewards will be calculated as below:',
    'ranking': 'Ranking',
    'totalBounty': 'Total Bounty',
    'split': 'Split',
    '4th-10th': '4th-10th Place',
    '11th-20th': '11th-20th Place',
    '21th-50th': '21th-50th Place',
    'termsAndConditions': 'Terms and conditions',
    'riskWarning': 'Risk warning',
    'riskTip': `Cryptocurrency investment is subject to high market risk. Binance is not responsible for any direct, indirect or 
    consequential losses as a result of the trading competition. Please make your investments with caution.`,
    'terms': [
      'Participants must use the same email account to register for the two futures platforms.',
      `The votes will be counted only from participants that engage in trading on the platforms in this activity, 
      with each participant having the right to one vote only.`,
      `Participants that vote for the platform that receives the most votes at the end of the competition will 
      receive a 50% trading fee discount for one (1) month on the winning platform.`,
      `Rewards will be issued within 2 weeks after the competition ends. You will be able to login and see your prize via 
      Distribution History > Account Center.`,
      'Trading volume refers to total buys and sells (excluding wash trades).',
      'The simulated USDT funds allocated to each account is for testing purposes only. ',
      `Binance reserves the right to cancel or amend the competition or competition rules at our sole discretion. 
      Binance reserves the right to disqualify trades that are deemed to be wash trades or display attributes of market manipulation.`,
      '*Testnet only; not transferable for real USDT',
    ],
    'voteStatus': {
      0: 'Voting has not started',
      2: 'Voting has ended',
      3: 'Voting has ended',
    },
    'voteTime': '2019/09/03 00:00 AM - 2019/09/08 00:00 AM (UTC)',
  },
  cn: {
    'pageTitle': '币安双合约争霸赛',
    'slogon': '打榜赢百万大奖',
    'tradeCompetitionPeriod': '活动时间',
    'bannerDesc': `为了更好的服务用户，Binance将上线合约交易平台（Binance Futures），并同时推出两个合约版本：合约A、合约B。
      现诚邀合约达人参与Binance合约模拟交易大赛，投票选出您最心仪的合约产品，所有参与的用户将有机会赢取价值百万的BNB。`,
    'Futures A': '合约A',
    'Futures B': '合约B',
    'chooseA': '我选 A',
    'chooseB': '我选 B',
    'PromotionADesc': (
      <>
        所有参与本次合约争霸赛的用户，可以投票选出自己最心仪的合约产品，有效票数最多的一方投票用户，在Binance合约产品（实盘）
        上线后<strong>1个月交易手续费享受50%优惠</strong>（可叠加其他优惠活动）。
      </>
    ),
    'PromotionBTitle': '参与模拟盘交易，赢取百万BNB大奖',
    'PromotionBDesc1': (
      <>
        活动期间，在合约A、合约B平台上都注册的用户，每平台获得100,000 USDT测试资金，参与模拟盘交易大赛。
        活动结束时，账户余额不少于初始资金的用户，将根据交易量进行排名，<strong>赢取10,000 BNB大奖</strong>。
      </>
    ),
    'PromotionBDesc2': '',
    'Futures A rankings': '合约A排名',
    'Futures B rankings': '合约B排名',
    'rewardTableTip': '奖励分配如下：',
    'ranking': '排名',
    'totalBounty': '奖金池',
    'split': '平分',
    '4th-10th': '第4-10名',
    '11th-20th': '第11-20名',
    '21th-50th': '第21-50名',
    'termsAndConditions': '服务协议',
    'riskWarning': '风险提示',
    'riskTip': '数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。Binance会遴选优质币种，但不对投资行为承担担保、赔偿等责任。',
    'terms': [
      '请使用相同的邮箱在两个合约平台注册并交易，未同时注册、未交易的用户投票不纳入统计；',
      '测试平台上的100,000 USDT均为虚拟资产，仅限测试使用；',
      '有效交易量：买入及卖出总量，不含账号对倒量；',
      '奖励发放：活动结束后2周内发放将统一发到获奖者的Binance账号，可在Binance用户中心-分发记录查看；',
      'Binance 保留对本次活动的最终解释权。',
    ],
    'voteStatus': {
      0: '投票未开启',
      2: '投票已结束',
      3: '投票已结束',
    },
    'voteTime': '2019年09月03日上午8:00 - 2019年09月08上午8:00（香港时间）',
  },
};
